import { render, staticRenderFns } from "./SelectSettingsModal.vue?vue&type=template&id=709fb2b8&scoped=true&lang=pug"
import script from "./SelectSettingsModal.vue?vue&type=script&lang=js"
export * from "./SelectSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./SelectSettingsModal.vue?vue&type=style&index=0&id=709fb2b8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709fb2b8",
  null
  
)

export default component.exports